module.exports = __webpack_public_path__ + "img/news_center.4a92ba5a.jpg";